/**
 * Copy text to clipboard. Works in both secure (HTTPS) and non-secure (HTTP) contexts.
 * navigator.clipboard is only available over HTTPS; on HTTP it's undefined.
 * @param {string} text - Text to copy
 * @returns {Promise<boolean>} - true if copy succeeded
 */
export async function copyToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return true;
  }
  // Fallback for HTTP or when clipboard API is unavailable
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  textArea.style.top = '-999999px';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    const success = document.execCommand('copy');
    return success;
  } finally {
    document.body.removeChild(textArea);
  }
}
